import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import useUserInfo from 'framework-listing-lib/internal/hooks/useUserInfo';
import { useLowercaseCrmObjectTypeName } from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibExportButton({
  modalProps = {}
}) {
  const {
    hasScope
  } = useUserInfo();
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const {
    lowerCaseObjectTypeNamePlural: objectTypeNamePlural,
    capitalizedObjectTypeNamePlural
  } = useLowercaseCrmObjectTypeName();
  const hasCrmExport = useMemo(() => hasScope('crm-export'), [hasScope]);
  const handleOpenModal = useCallback(() => {
    listingLibObserver.openExportModal(modalProps);
    trackCrmTableInteraction({
      action: 'open-export-modal'
    });
  }, [modalProps, trackCrmTableInteraction]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: hasCrmExport,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.tableActions.exportDisabledTooltip",
      options: {
        assetName: objectTypeNamePlural,
        capitalizedAssetName: capitalizedObjectTypeNamePlural
      }
    }),
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "crm-listing-export-button",
      disabled: !hasCrmExport,
      onClick: handleOpenModal,
      size: "extra-small",
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.tableActions.export",
        options: {
          assetName: objectTypeNamePlural,
          capitalizedAssetName: capitalizedObjectTypeNamePlural
        }
      })
    })
  });
}